import { merge } from "lodash";
import { getFilter } from "../collecter/get";
import { getSearch } from "../shared/global";
import reporter from "./reporter";

/**
 * pv埋点  用于没有路由变化的pv埋点，比如弹框、tab页切换等
 * @param {{
 *  search_word:string, // 搜索词
 *  search_word_type?: string, // 搜索词类型 1:手动输入搜索词 2:联想词搜索  等
 *  search_type?: string,
 *  search_result_number: number,
 *  filter_one: Array<string>
 * }} data 页面信息  page_name sub_page_nm
 */
export default function searchTracker(data, { bd_disabled } = {}) {
  if (typeof window === "undefined") return;

  // 异步为了取页面上的筛选器数据
  setTimeout(() => {
    try {
      const trackData = {
        event_id: 39005,
        event_name: "search",

        // 一系列空字段，避免SDK警告
        design_category_id: 0,
        filter_five: [],
        filter_four: [],
        filter_id: [],
        filter_six: [],

        // ⚠️ 重要：先合并全局 search 数据，再合并传入的 data
        // 这样确保传入的 data.search_word 优先于全局 search 中的旧值
        ...getSearch(),
        ...data,
      };

      merge(trackData, getFilter("搜索结果页"));

      reporter(trackData, { bd_disabled: bd_disabled });
    } catch (error) {
      console.error(error);
    }
  }, 0);
}
